import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState, NOT_SAVED_ID } from "app/model"
import { getFormatedNumber } from "app/tools/number"
import { getCurrencySymbol } from "form/inventory/tools/common"
import { IForm } from "form/model"
import { getForm, isCreateForm } from "form/tools/common"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"

interface IFormInventoryBudgetProps {
  form: IForm | null
  contentWidth: number
}

const FormInventoryBudgetFn = React.memo(({ form, contentWidth }: IFormInventoryBudgetProps): JSX.Element | null => {
  if (!form) {
    return null
  }
  const {
    tempCampaignId,
    configuration: { budget, main }
  } = form
  const totalBudget: number | null = budget.budget !== null && budget.budget > 0 ? budget.budget : null
  let dailyBudget: number | null = null
  if (budget.max_daily_spend) {
    dailyBudget = budget.max_daily_spend
  }
  const areDataInitialized = (!isCreateForm(form) || tempCampaignId !== NOT_SAVED_ID) && totalBudget !== null
  const currencySymbol = getCurrencySymbol(form.configuration.budget.currency_id)
  return (
    <FlexBox vertical ai="start" sx={{ maxWidth: "14rem" }}>
      {!areDataInitialized ? (
        <Typography fontSize=".8rem" sx={{ color: theme => theme.palette.text.primary2 }}>
          {translate(contentWidth < 525 ? "form.inventory.no.budget.short" : "form.inventory.no.budget")}
        </Typography>
      ) : (
        <>
          <Typography
            fontSize=".85rem"
            fontWeight={500}
            sx={{ color: theme => theme.palette.text.primary2, whiteSpace: "nowrap" }}>
            {translate("campaign.budget.target")}
          </Typography>
          <Typography fontSize=".75rem" sx={{ color: theme => theme.palette.text.primary2, whiteSpace: "nowrap" }}>
            {translate("campaign.budget.total")}{" "}
            <span style={{ fontWeight: 800, whiteSpace: "nowrap" }}>
              {currencySymbol} {getFormatedNumber(totalBudget as number)}
            </span>
          </Typography>
          <Typography fontSize=".75rem" sx={{ color: theme => theme.palette.text.primary2, whiteSpace: "nowrap" }}>
            {translate("campaign.budget.daily")}{" "}
            <span style={{ fontWeight: 500, whiteSpace: "nowrap" }}>
              {currencySymbol} ${dailyBudget ? getFormatedNumber(dailyBudget) : "-"}
            </span>
          </Typography>
          <Typography fontSize=".75rem" sx={{ color: theme => theme.palette.text.primary2, whiteSpace: "nowrap" }}>
            {translate("campaign.budget.max.bid")}{" "}
            <span style={{ fontWeight: 500, whiteSpace: "nowrap" }}>
              {currencySymbol} {budget.max_bid ? getFormatedNumber(budget.max_bid) : "-"}
            </span>
          </Typography>
        </>
      )}
    </FlexBox>
  )
})

export const FormInventoryBudget = connect(
  (state: IRootState): IFormInventoryBudgetProps => ({
    form: state.app.activeContext ? getForm(state) : null,
    contentWidth: state.ui.contentWidth
  })
)(FormInventoryBudgetFn)
